import { imgSbankSbankOnboardingBgFull01 } from "@/shared/assets/img";
import { Document5Icon } from "@/shared/icons/Document5Icon";
import Button from "@/shared/ui/button/Button";
import { BankBullet } from "@/domains/bank/components/BankBullet/BankBullet";
import { OnboardingFrame } from "@/domains/bank/components/Onboarding/OnboardingFrame";

type OnboardingStep01Props = {
  minServicePrice: number;
  onSubmit: () => void;
};

export function OnboardingStep01({ minServicePrice, onSubmit }: OnboardingStep01Props) {
  return (
    <OnboardingFrame
      style={{
        backgroundImage: `url(${imgSbankSbankOnboardingBgFull01})`,
      }}
    >
      <div className="flex flex-col w-[60%] h-full justify-between mt-10">
        {/* Welcome text */}
        <div className="flex flex-col gap-3">
          <h3 className="text-20 font-bold text-sbank">Стань клиентом банка</h3>

          <div>
            <strong>СБанк приветствует вас!</strong>
            <p className="font-normal leading-tight">
              Мы предоставляем все необходимые банковские услуги:
              <br />
              обслуживаем физических и юридических лиц, а также государственные предприятия.
            </p>
          </div>
        </div>

        {/* Benefits */}
        <div className="flex flex-col gap-8">
          {/* В блоке нет смысла без цены, поэтому скрываем */}
          {minServicePrice && (
            <div className="flex items-center gap-4">
              <BankBullet>₽</BankBullet>
              <div className="flex flex-col gap-1">
                <div className="text-18 font-bold leading-none text-white">
                  от {minServicePrice} ₽
                </div>
                <div className="text-15 leading-none text-white/50">Обслуживание клиентов</div>
              </div>
            </div>
          )}

          <Button
            variant="solid-gradient"
            data-mz-accent="success"
            className="w-[260px] gap-3"
            onClick={onSubmit}
          >
            <Document5Icon className="size-4.5" />
            Открыть счет
          </Button>
        </div>
      </div>
    </OnboardingFrame>
  );
}
